import { render, staticRenderFns } from "./ProposalsList.vue?vue&type=template&id=927e2974&scoped=true"
import script from "./ProposalsList.vue?vue&type=script&lang=js"
export * from "./ProposalsList.vue?vue&type=script&lang=js"
import style0 from "./ProposalsList.vue?vue&type=style&index=0&id=927e2974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e2974",
  null
  
)

export default component.exports